import { useEffect } from 'react'

import { SubmitHandler, UseFormProps, UseFormReturn } from 'react-hook-form'
import { z } from 'zod'

import { useFormWithSchema } from '@fortem-monorepo/react-spa'
import { Form } from '@fortem-monorepo/react-ui'

import { useRollRiskMutation } from '@/react-query/mutations/batch-executor'

const rollRiskSchema = z.object({
  date_t: z.string().nonempty('T is required'),
  date_tmo: z.string().nonempty('T-1 is required'),
})

export type RollRiskSchemaType = z.infer<typeof rollRiskSchema>

export interface RollRiskFormProps extends Omit<UseFormProps<RollRiskSchemaType>, 'resolver'> {
  children?: ((form: UseFormReturn<RollRiskSchemaType>) => React.ReactNode) | React.ReactNode
  onSubmit?: SubmitHandler<RollRiskSchemaType>
}

export const RollRiskForm: React.FC<RollRiskFormProps> = ({ onSubmit, children }) => {
  const form = useFormWithSchema({ mode: 'all' }, rollRiskSchema)

  const rollRiskMutation = useRollRiskMutation()

  const submit = form.handleSubmit(
    onSubmit ??
      ((_data) => {
        return rollRiskMutation.mutateAsync(_data)
      }),
  )

  useEffect(() => {
    form.trigger()
  }, [])

  return (
    <Form {...form}>
      <form onSubmit={submit}>{typeof children === 'function' ? children(form) : children}</form>
    </Form>
  )
}
